import { render } from "./DiscartModal.vue?vue&type=template&id=10d3a2d4"
import script from "./DiscartModal.vue?vue&type=script&lang=js"
export * from "./DiscartModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__